import Arbor from './arbor/index.js'
import { TrustedForm } from './thirdparty/TrustedForm'
import { Jornaya } from './thirdparty/Jornaya'
import { Ringba } from './thirdparty/Ringba'
import { BulkVisitorAnswerMetadataKey as MetadataKey } from './enums/BulkVisitorAnswerMetadataKey'
import { Hook } from './enums/HookEnum'

/* eslint-disable camelcase */
const trustedForm = new TrustedForm()
const ringba = new Ringba()
const jornaya = new Jornaya()

export const HookToFunctionMap = {
    [ Hook.BeforeStepSubmission ]: beforeStepSubmission,
    [ Hook.BeforeFormSubmission ]: beforeFormSubmission,
    [ Hook.AfterEnterThankYouPage ]: afterEnterThankYouPage,
    [ Hook.OnWebFormStart ]: onWebFormStart,
}

export function beforeStepSubmission(formData, metadata) {

    formData[ MetadataKey.Language ] = getLanguage()

    const trustedFormUrl = trustedForm.getTrustedFormUrl()
    const pubId = getPubIdFromUrl()

    if (trustedFormUrl) {
        formData[ MetadataKey.TrustedFormUrl ] = trustedFormUrl
    }

    const clonedFormData = Object.assign({}, formData)

    // Remove step so we don't send it to Third Parties
    delete clonedFormData.step

    if (pubId) {

        formData[ MetadataKey.PubId ] = pubId
        ringba.push({ pub_id: pubId })

    }

    ringba.push({ language: getLanguage() })
    ringba.pushFormData(clonedFormData)

    if (typeof dtpCallback === 'function' && pubId === null) {

        dtpCallback(function(clickId) {

            formData[ MetadataKey.PubId ] = clickId
            ringba.push({ pub_id: clickId })

        })

    }

    const leadiD = jornaya.getLeadiDToken()

    if (leadiD) {
        formData[ MetadataKey.JornayaId ] = leadiD
    }

    // Include Impression ID if it exists
    try {

        const storageKey = localStorage.getItem(`ringbaNumber_${ window.RINGBA_TAG }`)

        if (storageKey) {
            formData[ MetadataKey.RingbaImpressionId ] = JSON.parse(storageKey).impressionQueryPath
        }

    } catch (error) {
        // Prevent errors from showing in console.
    }

    // Associate vertical to leads
    if (metadata[ MetadataKey.Vertical ]) {
        formData[ MetadataKey.Vertical ] = metadata[ MetadataKey.Vertical ]
    }

}

export function beforeFormSubmission(formData, metadata) {

    if ((window.__SCRIPTS.trustedForm ?? true)) {
        trustedForm.stopRecording()
    }

}

export function afterEnterThankYouPage(metadata) {

    ringba.push({
        thankYouPage: true,
        ThankYouPageId: metadata.key,
    })

    if (metadata.tags) {

        for (const key in metadata.tags) {
            ringba.push({ [ `thank_you_page_${ key }` ]: metadata.tags[ key ] })
        }

    }

}

export function onWebFormStart() {

    if ((window.__SCRIPTS.trustedForm ?? true)) {
        trustedForm.createScript()
    }

    if ((window.__SCRIPTS.jornaya ?? true)) {
        jornaya.createScript()
    }

    Arbor.store('qv').ringba.ensureLoaded()

}

function getPubIdFromUrl() {

    const pubId = location.search.match(/pub_id=(?<id>[\w|-]+)/)

    if (pubId && pubId.groups && pubId.groups.id) {
        return pubId.groups.id
    }

    return null

}

function getLanguage() {

    const languageMap = {
        en: 'english',
        es: 'spanish',
    }

    const languageCode = navigator.language.slice(0, 2)

    return languageMap[ languageCode ] || null

}
